export default {
  baseUrl: process.env.VUE_APP_REQUEST_BASE_URL,
  adminCenterUrl: process.env.VUE_APP_REQUEST_ADMIN_BASE_URL,
  casUrl: process.env.VUE_APP_CAS_URL,
  adminPlatformUrl: process.env.VUE_APP_ADMIN_PLATFORM_URL,
  projectName: process.env.VUE_APP_PROJECT_NAME,
  personalCenterBaseUrl: process.env.VUE_APP_PERSONAL_CENTER_BASE_URL,
  LOGIN_WAY:process.env.VUE_APP_LOGIN_WAY,
  AUTH_SETTING:process.env.VUE_APP_LOGIN_AUTH_SETTING,
  VUE_APP_URL:process.env.VUE_APP_URL,
  portalCenterUrl: process.env.VUE_APP_PORTAL_CENTER_URL
}